import {Component} from '@angular/core';
import {HomepageQuestionModel} from "../../../models/homepageQuestion.model";
import {FrequentlyAskedQuestionsFactory} from "./frequently-asked-questions-factory.service";
import {TranslateService} from "@ngx-translate/core";
import {Language} from "../../../models/language";

@Component({
  selector: 'app-frequently-asked-questions',
  templateUrl: './frequently-asked-questions.component.html',
  styleUrls: ['./frequently-asked-questions.component.scss', './frequently-asked-questions-media.component.scss']
})
export class FrequentlyAskedQuestionsComponent {

  currentLang: string = '';

    protected readonly Language = Language;

  constructor(public translate: TranslateService) {
    this.currentLang = this.translate.currentLang || Language.HY;
    this.translate.onLangChange.subscribe((event) => {
      this.currentLang = event.lang;
    });
  }

  protected readonly questions: Array<HomepageQuestionModel[]> = FrequentlyAskedQuestionsFactory.questions;

  protected toggleAnswerVisibility(id: number): void {
    for (let section of this.questions) {
      for (let question of section) {
        if (question.id === id) {
          question.showAnswer = !question.showAnswer;
          break;
        }
      }
    }
  }

}
